<template>
  <section class="editorWrap">
    <link
      href="https://cdn.quilljs.com/1.3.6/quill.snow.css"
      rel="stylesheet"
    />
    <div id="editor" ref="editor" />
    <div ref="image-picker" />
    <ImageManager
      v-if="showImageModal"
      :isModal="true"
      @changed="onSelectedImage"
      @close="showImageModal = false"
    />
  </section>
</template>

<script>
import Quill from "quill";
import ImageResize from "@taoqf/quill-image-resize-module";
import ImageManager from "@/components/MediaPage/MediaImages";

export default {
  props: {
    value: {
      type: String,
      default: "",
    },
    unsetHeight: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ImageManager,
  },
  data() {
    return {
      editor: null,
      showImageModal: false,
    };
  },
  mounted() {
    var Font = Quill.import("formats/font");
    var Size = Quill.import("attributors/style/size");

    Font.whitelist = ["poppins", "brandon", "arial", "barlow"];
    Size.whitelist = ["10pt", "12pt", "14pt", "16pt", "20pt", "24pt", "32pt"];

    Quill.register(Font, true);
    Quill.register(Size, true);
    Quill.register("modules/imageResize", ImageResize);

    this.editor = new Quill(this.$refs.editor, {
      modules: {
        imageResize: {
          modules: ["Resize"],
        },
        toolbar: {
          container: [
            [
              { header: [1, 2, 3, false] },
              { size: Size.whitelist },
              { font: Font.whitelist },
              { color: [] },
              { background: [] },
            ],
            ["bold", "italic"],
            [{ align: "" }, { align: "center" }, { align: "right" }],
            [{ list: "ordered" }, { list: "bullet" }],
            ["clean"],
            ["link", "image", "video", "custom-button"],
          ],
        },
      },
      placeholder: "Write your text here...",
      theme: "snow",
    });

    this.editor.root.innerHTML = this.value;
    this.editor.on("text-change", () => this.update());

    var customButton = document.querySelector(".ql-custom-button");
    customButton.addEventListener("click", () => {
      this.showImageModal = true;
    });

    if (this.unsetHeight) {
      document.querySelector(".ql-editor").style.maxHeight = "unset";
    }
  },

  methods: {
    update() {
      this.$emit(
        "input",
        this.editor.getText() ? this.editor.root.innerHTML : ""
      );
    },
    onSelectedImage(image) {
      const range = this.editor.getSelection();
      const imageHtml = `<p><img class="responsive" style="display: block; margin-left: auto; margin-right: auto; cursor:move" src="${image}" alt="second img" /></p>`;
      this.editor.clipboard.dangerouslyPasteHTML(
        range ? range.index : 0,
        imageHtml
      );
    },
  },
};
</script>

<style>
.ql-editor {
  min-height: 300px;
  max-height: 300px;
}

/*
    Paragraph style picker code
  */

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item {
  content: "Styles" !important;
  font-family: "Poppins";
}

/*
    Font type picker code
  */

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="poppins"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="poppins"]::before {
  content: "Poppins";
  font-family: "Poppins";
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="brandon"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="brandon"]::before {
  content: "Brandon TB";
  font-family: "Brandon Text Black";
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="barlow"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="barlow"]::before {
  content: "Barlow";
  font-family: "Barlow";
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="arial"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="arial"]::before {
  content: "Arial";
  font-family: "Arial";
}

.ql-font-poppins {
  font-family: "Poppins";
}

.ql-font-brandon {
  font-family: "Brandon Text Black";
}

.ql-font-arial {
  font-family: "Arial";
}

.ql-font-barlow {
  font-family: "Barlow";
}

/*
    Font size picker code
  */

.ql-snow .ql-picker.ql-size {
  font-family: "Poppins";
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="10pt"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="10pt"]::before {
  content: "10pt";
  font-size: 10pt;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="12pt"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="12pt"]::before {
  content: "12pt";
  font-size: 12pt;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="14pt"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="14pt"]::before {
  content: "14pt";
  font-size: 14pt;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="16pt"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="16pt"]::before {
  content: "16pt";
  font-size: 16pt;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="20pt"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="20pt"]::before {
  content: "20pt";
  font-size: 20pt;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="24pt"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="24pt"]::before {
  content: "24pt";
  font-size: 24pt;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="32pt"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="32pt"]::before {
  content: "32pt";
  font-size: 32pt;
}

.ql-snow .ql-picker.ql-size .ql-picker-label::before {
  font-size: 14px !important;
}

/*
    Custom image button code
  */

.ql-custom-button:after {
  content: url("data:image/svg+xml,%3Csvg version='1.1' id='Capa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 469.333 469.333' style='enable-background:new 0 0 469.333 469.333;' xml:space='preserve'%3E%3Cg%3E%3Cg%3E%3Cpath d='M426.667,64h-384C19.093,64,0,83.093,0,106.667v256c0,23.573,19.093,42.667,42.667,42.667h384 c23.573,0,42.667-19.093,42.667-42.667v-256C469.333,83.093,450.24,64,426.667,64z M85.333,341.333l74.667-96l53.333,64.107 L288,213.333l96,128H85.333z'/%3E%3C/g%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3C/svg%3E");
}

.ql-custom-button:hover:after {
  content: url("data:image/svg+xml,%3Csvg version='1.1' id='Capa_1' fill='%2348B9BA' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 469.333 469.333' style='enable-background:new 0 0 469.333 469.333;' xml:space='preserve'%3E%3Cg%3E%3Cg%3E%3Cpath d='M426.667,64h-384C19.093,64,0,83.093,0,106.667v256c0,23.573,19.093,42.667,42.667,42.667h384 c23.573,0,42.667-19.093,42.667-42.667v-256C469.333,83.093,450.24,64,426.667,64z M85.333,341.333l74.667-96l53.333,64.107 L288,213.333l96,128H85.333z'/%3E%3C/g%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3C/svg%3E") !important;
}

/*
    Snow theme overwrites
  */

.ql-snow.ql-toolbar button:hover,
.ql-snow .ql-toolbar button:hover,
.ql-snow.ql-toolbar button:focus,
.ql-snow .ql-toolbar button:focus,
.ql-snow.ql-toolbar button.ql-active,
.ql-snow.ql-toolbar .ql-picker-item:hover,
.ql-snow .ql-toolbar .ql-picker-item:hover,
.ql-snow.ql-toolbar .ql-picker-label:hover,
.ql-snow .ql-toolbar .ql-picker-label:hover,
.ql-snow .ql-toolbar button.ql-active {
  color: #48b9ba !important;
}

.ql-snow.ql-toolbar .ql-picker-label.ql-active,
.ql-snow .ql-toolbar .ql-picker-label.ql-active,
.ql-snow.ql-toolbar .ql-picker-item.ql-selected,
.ql-snow .ql-toolbar .ql-picker-item.ql-selected {
  color: #000000 !important;
}

.ql-snow.ql-toolbar button:hover .ql-fill,
.ql-snow .ql-toolbar button:hover .ql-fill,
.ql-snow.ql-toolbar button:focus .ql-fill,
.ql-snow .ql-toolbar button:focus .ql-fill,
.ql-snow.ql-toolbar button.ql-active .ql-fill,
.ql-snow .ql-toolbar button.ql-active .ql-fill,
.ql-snow.ql-toolbar button:hover .ql-stroke.ql-fill,
.ql-snow .ql-toolbar button:hover .ql-stroke.ql-fill,
.ql-snow.ql-toolbar button:focus .ql-stroke.ql-fill,
.ql-snow .ql-toolbar button:focus .ql-stroke.ql-fill,
.ql-snow.ql-toolbar button.ql-active .ql-stroke.ql-fill,
.ql-snow .ql-toolbar button.ql-active .ql-stroke.ql-fill {
  fill: #48b9ba !important;
}
.ql-snow.ql-toolbar button:hover .ql-stroke,
.ql-snow .ql-toolbar button:hover .ql-stroke,
.ql-snow.ql-toolbar button:focus .ql-stroke,
.ql-snow .ql-toolbar button:focus .ql-stroke,
.ql-snow.ql-toolbar button.ql-active .ql-stroke,
.ql-snow .ql-toolbar button.ql-active .ql-stroke,
.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke,
.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke,
.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke,
.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke,
.ql-snow.ql-toolbar button:hover .ql-stroke-miter,
.ql-snow .ql-toolbar button:hover .ql-stroke-miter,
.ql-snow.ql-toolbar button:focus .ql-stroke-miter,
.ql-snow .ql-toolbar button:focus .ql-stroke-miter,
.ql-snow.ql-toolbar button.ql-active .ql-stroke-miter,
.ql-snow .ql-toolbar button.ql-active .ql-stroke-miter,
.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke-miter,
.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke-miter,
.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,
.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,
.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke-miter,
.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke-miter,
.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,
.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter {
  stroke: #48b9ba !important;
}

.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke,
.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke,
.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke,
.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke {
  stroke: #000000 !important;
}

.ql-snow.ql-toolbar {
  border-radius: 8px 8px 0px 0px !important;
  border: 2px solid var(--grey) !important;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.ql-snow.ql-toolbar button,
.ql-snow .ql-toolbar button {
  box-shadow: none !important;
  height: 46px !important;
  padding: 12px 6px !important;
  width: 34px !important;
}

.ql-container.ql-snow {
  border-bottom: 2px solid var(--grey) !important;
  border-left: 2px solid var(--grey) !important;
  border-right: 2px solid var(--grey) !important;
  border-radius: 0px 0px 8px 8px !important;
}

.ql-container.ql-snow:focus-within {
  border-bottom: 2px solid #48b9ba !important;
  border-left: 2px solid #48b9ba !important;
  border-right: 2px solid #48b9ba !important;
  border-radius: 0px 0px 8px 8px !important;
}

.editorWrap:focus-within > .ql-snow.ql-toolbar {
  border-radius: 8px 8px 0px 0px !important;
  border: 2px solid #48b9ba !important;
}

/* This will create a small divider line between button groups
  /* .ql-toolbar.ql-snow .ql-formats {
    padding-right: 8px !important;
    padding-left: 8px !important;
    margin-right: 0px !important;
    border-right: 1px solid var(--grey) !important;
  } */
</style>
